import { Link, useLocation } from "react-router-dom";
import { Home, Waves, PartyPopper } from "lucide-react";

const TABS = [
  { label: "Home", path: "/", icon: Home },
  { label: "Water Slides", path: "/water-slides-rentals", icon: Waves },
  { label: "Party Rentals", path: "/party-rentals", icon: PartyPopper },
];

export default function BottomTabBar() {
  const location = useLocation();

  return (
    <nav
      className="sm:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur border-t border-border flex"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map(({ label, path, icon: Icon }) => {
        const active = location.pathname === path;
        return (
          <Link
            key={path}
            to={path}
            className="flex-1 flex flex-col items-center justify-center py-3 gap-0.5 transition-colors select-none"
            style={{ WebkitTapHighlightColor: "transparent" }}
          >
            <Icon
              className={`w-6 h-6 transition-colors ${active ? "text-primary" : "text-muted-foreground"}`}
            />
            <span
              className={`text-[10px] font-semibold transition-colors ${active ? "text-primary" : "text-muted-foreground"}`}
            >
              {label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}